export const finishedQueue = (state) => state.finishedQueue;
export const eventDetails = (state) => state.eventDetails;
export const loading = (state) => state.loading;
export const snackbarContent = (state) => state.snackbarContent;
export const expirationDialog = (state) => state.expirationDialog;
export const queue = (state) => state.queue;
export const storeDetails = (state) => state.storeDetails;
export const namedTickets = (state) => state.namedTickets;
export const selectedLanguage = (state) => state.selectedLanguage;
export const firstPayment = (state) => state.firstPayment;
export const pendingOrder = (state) => state.pendingOrder;
export const orderProducts = (state) => state.orderProducts;
export const orderAmount = (state) => {
  if (state.orderProducts) {
    let total = 0;
    state.orderProducts.forEach((p) => {
      total += p.quantidade * (Number(p.valor) + Number(p.valor_conveniencia));
    });
    return total;
  } else return 0;
};
